import { render, staticRenderFns } from "./currencyInfo.vue?vue&type=template&id=0e4f210a&lang=pug&"
import script from "./currencyInfo.vue?vue&type=script&lang=ts&"
export * from "./currencyInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports